/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import {
  integerValueFields,
  stringValueFields,
  isUUID
} from '../../utils/shared';

const IndeterminateCheckbox = props => {
  const { value, label, elementId, disallowExcluded, ...otherProps } = props;

  let emptyIncluded = ['title', 'allowed-pages', 'allowed-countries'];
  if (window.location.pathname === '/attribution/platform') {
    emptyIncluded = ['platform', 'network', 'studio', 'genre'];
  }
  if (window.location.pathname === '/report-builder') {
    emptyIncluded = ['allowed-pages', 'allowed-countries'];
  }

  const nextStateLookup = emptyIncluded.includes(props.selectProps.id)
    ? {
        included: 'empty',
        empty: 'included'
      }
    : {
        included: 'excluded',
        excluded: 'empty',
        empty: 'included'
      };

  const convertPropsValue = (v, id) => {
    if (integerValueFields.includes(id) && v.startsWith('not')) {
      return parseInt(v.replace('not', ''), 10);
    }
    if (integerValueFields.includes(id)) {
      return parseInt(v, 10);
    }
    if (stringValueFields.includes(id) && v.startsWith('-')) {
      return v.substring(1);
    }
    if (id === 'title' && v.includes('-') && v.startsWith('-')) {
      return v.substring(1);
    }
    if (id === 'title' && !v.includes('-') && v.startsWith('not')) {
      return parseInt(v.replace('not', ''), 10);
    }
    if (id === 'title' && !v.includes('-')) {
      return parseInt(v, 10);
    }
    return v;
  };

  const sanitizeBase = (v, id) => {
    if (
      integerValueFields.includes(id) &&
      !(id === 'title' && parseInt(v, 10) !== v)
    ) {
      return parseInt(v, 10);
    }
    return v;
  };

  const formatExcludedValue = (v, id) => {
    if (integerValueFields.includes(id)) {
      return `not ${v}`.replace('-', '');
    }
    if (id === 'title' && !isUUID(v)) {
      return `not ${v}`.replace('-', '');
    }
    return `-${v}`;
  };
  // End of helper functions

  const getCurrentState = () => {
    // eslint-disable-next-line no-restricted-globals
    const propsValue = isNaN(props.value) ? props.value : Math.abs(props.value);
    if (
      props.selectProps.id === 'allowed-countries' ||
      props.selectProps.id === 'allowed-pages'
    ) {
      const foundValues =
        props.selectProps && props.selectProps.value
          ? props.selectProps.value.filter(item => {
              return item.value === propsValue;
            })
          : [];
      if (foundValues.length) {
        return 'included';
      }
    } else {
      const foundValues =
        props.selectProps && props.selectProps.value
          ? props.selectProps.value.filter(item => {
              return item.base === propsValue;
            })
          : [];
      if (foundValues.length) {
        if (foundValues[0].state === 'included') {
          return 'included';
        } else if (foundValues[0].state === 'excluded') {
          return 'excluded';
        }
      }
    }
    return 'empty';
  };

  let currentState = getCurrentState();
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    currentState = getCurrentState();
  }, [props.selectProps.value]);

  const handleChange = () => {
    const nextState = nextStateLookup[currentState];
    let newLabel = label;
    let newValue = `${value}`;
    let newState;

    if (nextState === 'excluded') {
      newLabel = `Excludes: ${label}`;
      newValue = formatExcludedValue(value, props.selectProps.id);
      newState = 'excluded';
    } else if (nextState === 'included') {
      newState = 'included';
    } else {
      newState = 'empty';
    }

    props.onChange({
      label: newLabel,
      value: newValue,
      state: newState,
      base: sanitizeBase(value, props.selectProps.id)
    });
  };

  return (
    <>
      <input id={value} type="checkbox" value={value} onChange={handleChange} />
      <label htmlFor={value} className={currentState} />
    </>
  );
};

export default IndeterminateCheckbox;
